// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0e380e42","455":"237427b9","977":"56ac041b"}[chunkId] + ".chunk.js";
};